import React, { useState } from 'react';
import TermSkeleton from './Term/TermSkeleton';

const Term = () => {
    const [isLoaded, setIsLoaded] = useState(false);

    const handleLoad = () => {
        setIsLoaded(true);
    };
    return (
        <>
            {!isLoaded && <TermSkeleton />}
            <iframe
                className="term"
                src="https://zeely.app/termContent.html"
                frameBorder="0"
                onLoad={handleLoad}
                style={{ display: isLoaded ? "block" : "none" }}
            ></iframe>
        </>

    );
}

export default Term;
